import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Input, Typography, Select, Alert, message, notification } from "antd";
import RateApi from "../../common/Apis/RatesApi";
import { createDefaultSubscription } from "../../../models/Subscription/TenantBillingDTO";
import BillingCycle from "../../../models/Rate/BillingCycleEnum";
// import { BillingCycle } from '../../../models/Rate/BillingCycleEnum';

const { Title } = Typography;
const { Option } = Select;

const CreatePaymentModal = ({ show, onClose, onSubmit, tenant }) => {
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [apiError, setApiError] = useState(null);

    const expireDate = tenant?.statusEndDate ? new Date(tenant.statusEndDate) : null;
    const today = new Date();

    // Calculate days remaining only if expireDate exists
    let diffDays = null;
    if (expireDate) {
        const utc1 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
        const utc2 = Date.UTC(expireDate.getFullYear(), expireDate.getMonth(), expireDate.getDate());
        diffDays = Math.ceil((utc2 - utc1) / (1000 * 60 * 60 * 24));
    }

    // useEffect(() => {
    //     validateRequiredFields();
    //     if (show) {
    //         form.resetFields();
    //         setIsButtonDisabled(true);
    //         setLoading(false);
    //         setApiError(null);
    //     }
    // }, [show, form]);

    useEffect(() => {
        if (show && tenant) {
            form.setFieldsValue({
                paymentTerm: tenant.billingCycle || undefined,
                rate:
                    tenant.billingCycle === BillingCycle.MONTHLY
                        ? tenant.monthlyRate
                        : tenant.annualRate,
            });
            setIsButtonDisabled(false);
            setLoading(false);
            setApiError(null);
        }
    }, [show, tenant, form]);

    const handleFieldsChange = () => {
        validateRequiredFields();
    };

    const validateRequiredFields = () => {
        let requiredFields = ["paymentTerm"];
        const hasErrors = form.getFieldsError(requiredFields).some(({ errors }) => errors.length > 0);
        const touchedRequiredFields = requiredFields.every((field) => form.isFieldTouched(field));
        setIsButtonDisabled(!touchedRequiredFields || hasErrors);
    };

    const handleRenew = async () => {

        form.validateFields(["paymentTerm"])
            .then((values) => {
                if (!tenant?.id) {
                    return message.error("Tenant ID is missing.");
                }

                const payload = createDefaultSubscription({
                    billingCycle: values.paymentTerm,
                    // monthlyRate: values.paymentTerm === BillingCycle.MONTHLY ? parseFloat(values.rate) : 0,
                    // annualRate: values.paymentTerm === BillingCycle.ANNUAL ? parseFloat(values.rate) : 0,
                    paymentStatus: "PAID",
                    // statusStartDate: new Date().toISOString().split("T")[0],
                    // statusEndDate: new Date().toISOString().split("T")[0],
                });

                setLoading(true);
                RateApi.RenewSubscription(tenant?.id, payload)
                    .then(() => {
                        setApiError(null);
                        notification.open({
                            message: <span style={{ fontWeight: "bold" }}>Subscription Renewed</span>,
                            closeIcon: false,
                            duration: 3,
                            style: {
                                backgroundColor: "#b3ffb3",
                                color: "green",
                            },
                        });
                        setLoading(false);
                        // onSubmit?.(); // Refresh parent
                        onClose();
                    })
                    .catch((err) => {
                        setApiError(
                            err?.apiError?.message ||
                            err?.message ||
                            "Failed to renew subscription. Please try again."
                        );
                        setLoading(false);
                    });
            })
            .catch(() => {
                message.error("Please fix the form errors before proceeding.");
            });
    };

    return (
        <Modal
            footer={null}
            width={650}
            open={show}
            maskClosable={false}
            onCancel={onClose}
            closable={true}
        >
            <Title level={4} className="text-center mb-3">
                Subscription
            </Title>

            {tenant?.paymentStatus === "TRIAL" && expireDate && (
                <Alert
                    message={`Tenant is under trial and will expire on ${expireDate.toLocaleDateString(
                        "en-IE",
                        { day: "numeric", month: "long", year: "numeric" }
                    )} (${diffDays} day${diffDays !== 1 ? "s" : ""} left)`}
                    type="info"
                    showIcon
                    className="mb-3"
                />
            )}

            {tenant?.paymentStatus === "PAID" && (
                <Alert
                    message={`This tenant is already in a paid billing cycle`}
                    type="success"
                    showIcon
                    className="mb-3"
                />
            )}

            {tenant?.paymentStatus !== "PAID" && <Form
                form={form}
                layout="vertical"
                name="create_payment_form"
                onFieldsChange={handleFieldsChange}
            >
                <Form.Item
                    name="paymentTerm"
                    label={
                        <span>
                            Payment Term <span style={{ color: "red" }}>*</span>
                        </span>
                    }
                    rules={[{ required: true, message: "Please select payment term" }]}
                >
                    <Select placeholder="Select Payment Term">
                        <Option value="MONTHLY">Monthly</Option>
                        <Option value="ANNUALLY">Annual</Option>
                    </Select>
                </Form.Item>

                {/* <Form.Item
    label={
      <span>
        Rate <span style={{ color: "red" }}>*</span>
      </span>
    }
    name="rate"
    rules={[
      { required: true, message: "Please enter rate" },
      {
        validator(_, value) {
          if (isNaN(value)) {
            return Promise.reject("Rate must be a number");
          }
          if (Number(value) < 0) {
            return Promise.reject("Rate cannot be negative");
          }
          return Promise.resolve();
        },
      },
    ]}
  >
    <Input placeholder="Enter rate" />
  </Form.Item> */}

                {apiError && (
                    <Alert message={apiError} type="error" showIcon className="mb-3" />
                )}

                <Button
                    type="primary"
                    disabled={isButtonDisabled}
                    loading={loading}
                    style={{ width: "100%" }}
                    onClick={handleRenew}
                >
                    Renew Subscription
                </Button>
            </Form>}

        </Modal>
    );
};

export default CreatePaymentModal;
